import React from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSmile } from '@fortawesome/free-regular-svg-icons';
import { faTelegramPlane } from '@fortawesome/free-brands-svg-icons';

import './SendMessage.css';

const validationSchema = Yup.object({
    content: Yup.string().required("Please enter a message"),
});

export default function SendMessage(props) {
    const inputRef = React.useRef(null);

    React.useEffect(() => {
        // auto focus if user has signed in
        if (inputRef.current) {
            inputRef.current.focus();
        }
    }, []);

    const handleKeyUp = (event) => {
        props.onKeyUp(event);
    }

    const handleSubmit = (values, { resetForm }) => {
        props.onSubmit(values);
        resetForm();
    };
    
    const formik = useFormik({
        initialValues: {
            content: ""
        },
        validationSchema: validationSchema,
        onSubmit: handleSubmit,
    });

    return (
        <div className="chat-footer">
            {props.currentUser ? (
                <form autoComplete="off" onSubmit={formik.handleSubmit}>
                    <input
                        ref={inputRef}
                        className="form-control chat_form"
                        name="content"
                        type="text"
                        value={formik.values.content}
                        placeholder="Mesaj Yazın."
                        onChange={formik.handleChange}
                        onKeyUp={handleKeyUp}
                    />
                    <div className="form-buttons">
                        <button className="btn" type="button">
                            <FontAwesomeIcon icon={faSmile} />
                        </button>
                        <button className="btn send-btn" type="submit">
                            <FontAwesomeIcon icon={faTelegramPlane} />
                            {formik.touched.content && Boolean(formik.errors.content) ? null : null}
                        </button>
                    </div>
                </form>
            ) : (
                <span>
                    Müzakirələrə qoşularaq mesaj yazmaq üçün <a href="/signin">hesabınıza</a> daxil olmalısınız!
                </span>
            )}
        </div>
    );
}
